// Modules
import { useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"

// Constants
import PATHS from "~constants/paths"

// Context
import { useAuthContext } from "~context/authContext"

const usePrivatePath = () => {
  const navigate = useNavigate()
  const location = useLocation()

  // Get from context
  const { loggedUser, isLoggedIn, isLoading } = useAuthContext()
  const isUserLoggedIn = isLoggedIn()

  // Use Effect
  useEffect(() => {
    // Don't redirect while session restore is in flight
    if (isLoading) return

    if (!isUserLoggedIn) {
      const redirect = location.pathname.split("/").pop() || null
      navigate(PATHS.login, { state: { redirect } })
    }
  }, [loggedUser, isLoading]) // eslint-disable-line react-hooks/exhaustive-deps

  return { isUserLoggedIn, loggedUser, isLoading }
}

export default usePrivatePath
